export const mapSpeakerVersionToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfGroup: item.releaseGroups?.length || 0,
    typeSpeakerName: item.typeSpeaker?.name,
  }));

  return result;
};

export const MODE_RELEASE_SPEAKER = {
  releaseOnGroup: "releaseOnGroup",
  releaseMass: "releaseMass",
};

export const speakerVersionColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "versionName", label: "Version Name", align: "center" },
  { key: "versionCode", label: "Version Code", align: "center" },
  { key: "action", label: "Action", align: "center" },
  { key: "typeSpeakerName", label: "Type Speaker", align: "center" },
  { key: "numOfGroup", label: "Num Of Group", align: "center" },
];
